// extracted by mini-css-extract-plugin
export default {"search-bar-root":"SearchBarNew_search-bar-root__Rn-oF","quick-search-button":"SearchBarNew_quick-search-button__WDhbQ"};